import React, { useState, useEffect } from "react";
import { 
  FaSearch, 
  FaBook, 
  FaCheckCircle, 
  FaCalculator 
} from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";
import api from "../axios/api";

const CursosCatalogo = () => {
  const [cursos, setCursos] = useState([]);
  const [emolumentoCursos, setEmolumentoCursos] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      try {
        const [resCursos, resEmolumentoCursos] = await Promise.all([
          api.get("/cursos"),
          api.get("/emolumento-cursos")
        ]);

        const dadosCursos = Array.isArray(resCursos.data) ? resCursos.data : (resCursos.data.data || []);
        const dadosEmolumentoCursos = Array.isArray(resEmolumentoCursos.data) ? resEmolumentoCursos.data : (resEmolumentoCursos.data.data || []);
        
        if (isMounted) {
          setCursos(dadosCursos);
          setEmolumentoCursos(dadosEmolumentoCursos);
        }
      } catch (error) {
        console.error("Erro ao carregar dados dos cursos e emolumentos:", error);
      }
    };

    fetchData();
    return () => { isMounted = false; };
  }, []);

  // Soma os preços diretamente com base na tabela emolumento-cursos do backend
  const cursosComSomaPrecos = cursos
    .filter(curso => curso.status !== 0 && curso.status !== "0" && curso.status !== false)
    .map(curso => {
      const cursoId = String(curso.id);
      
      const itensDoCurso = emolumentoCursos.filter(ec => {
        const ecCursoId = String(ec.curso_id || ec.id_curso || ec.curso?.id || "");
        return ecCursoId === cursoId;
      });

      let somaTotal = 0;
      itensDoCurso.forEach(item => {
        const valorNumerico = parseFloat(item.preco || item.valor || item.emolumento_preco?.valor || 0);
        if (!isNaN(valorNumerico)) {
          somaTotal += valorNumerico;
        }
      });

      return {
        ...curso,
        precoTotal: somaTotal
      };
    });

  const cursosFiltrados = cursosComSomaPrecos.filter(curso => {
    const termo = searchTerm.toLowerCase();
    const nome = (curso.nome || "").toLowerCase();
    const descricao = (curso.descricao || "").toLowerCase();

    return nome.includes(termo) || descricao.includes(termo);
  });

  return (
    <main className="bg-white text-dark">
      <Header />

      <section className="bg-black text-white py-5 position-relative overflow-hidden">
        <div className="container py-4 text-center position-relative z-2">
          <span className="text-warning fw-bold text-uppercase tracking-wider small mb-2 d-block">
            Início / Cursos
          </span>
          <h1 className="display-4 fw-bold mb-3">
            Nossos <span className="text-warning">Cursos</span>
          </h1>
          <p className="lead text-light opacity-75 mx-auto mb-4" style={{ maxWidth: '700px' }}>
            Explore a oferta formativa disponível na nossa instituição e os respetivos custos totais associados.
          </p>
        </div>
      </section>

      <section className="py-4 bg-light border-bottom">
        <div className="container">
          <div className="row g-3 align-items-center">
            <div className="col-lg-12">
              <div className="input-group">
                <span className="input-group-text bg-white border-end-0 text-muted"><FaSearch /></span>
                <input 
                  type="text" 
                  className="form-control border-start-0 shadow-none" 
                  placeholder="Pesquisar por nome ou descrição do curso..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <span className="text-muted small">Mostrando cursos ativos disponíveis</span>
            <span className="badge bg-dark text-warning p-2">Total: {cursosFiltrados.length} cursos</span>
          </div>

          <div className="row g-4">
            {cursosFiltrados.length > 0 ? (
              cursosFiltrados.map((curso, index) => (
                <div key={curso.id || index} className="col-md-6 col-lg-4">
                  <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden bg-light">
                    {curso.foto && (
                      <div style={{ height: '200px', overflow: 'hidden' }} className="bg-secondary position-relative">
                        <img 
                          src={curso.foto} 
                          alt={curso.nome || "Curso"} 
                          className="w-100 h-100 object-fit-cover"
                        />
                      </div>
                    )}
                    <div className="card-body p-4 d-flex flex-column">
                      <div className="d-flex align-items-center gap-2 mb-2">
                        <FaBook className="text-warning" />
                        <h5 className="fw-bold mb-0 text-dark">{curso.nome || "Curso sem nome"}</h5>
                      </div>
                      <p className="text-muted small mb-3 flex-grow-1">
                        {curso.descricao || "Sem descrição informada para este curso."}
                      </p>
                      
                      <div className="p-3 bg-white rounded-3 border mb-3 d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-2 text-dark">
                          <FaCalculator className="text-warning" />
                          <span className="small fw-semibold">Preço:</span>
                        </div>
                        <span className="badge bg-dark text-warning px-2 py-1">
                          {curso.precoTotal.toLocaleString()} Kz
                        </span>
                      </div>

                      <div className="d-flex align-items-center justify-content-between pt-3 border-top mt-auto">
                        <span className="badge bg-success text-white px-2 py-1 small d-flex align-items-center gap-1">
                          <FaCheckCircle size={10} /> Disponivel
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center py-5 bg-light rounded-4 border">
                <h5 className="text-dark fw-bold mb-2">Nenhum curso encontrado</h5>
                <p className="text-muted small mb-0">Não há cursos ativos correspondentes à sua pesquisa.</p>
              </div>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default CursosCatalogo;